export default __webpack_public_path__ + "static/media/Slide10.969c357d.PNG";